import { InvoiceState } from '@treadinc/horizon-api-spec';

import { Invoice } from '~hooks/useInvoices/models';

// An invoice counts as billing-approved once it reaches an approved/paid state.
// `approvable === false` alone is NOT sufficient — a locked, pending-but-locked,
// or voided invoice is also non-approvable yet is NOT approved, which would show
// a false "approved" success chip to the reviewer.
const APPROVED_INVOICE_STATES = [
  InvoiceState.APPROVED,
  InvoiceState.CUSTOMER_APPROVED,
  InvoiceState.PAID,
  InvoiceState.CUSTOMER_PAID,
];

export const isInvoiceApproved = (invoice: Invoice | null): boolean =>
  invoice !== null && APPROVED_INVOICE_STATES.includes(invoice.state);
